// extracted by mini-css-extract-plugin
module.exports = {"Container":"menu-select-title_Container__GPERY"};